export interface PlacedDepartment {
  id: string;
  branchId: string;
  name: string;
}

export function initialLogin(existingUser: boolean): boolean {
  return existingUser;
}

export function loginAfterDesignation(current: boolean, chosenIsDoctor: boolean, mayCreateLogin: boolean): boolean {
  return current || (chosenIsDoctor && mayCreateLogin);
}

export function departmentIdsOfPerson(
  user: { departmentId: string | null; departmentIds?: readonly string[] } | null,
  employee: { departmentId?: string | null; departmentIds?: readonly string[] } | null,
): string[] {
  if (user?.departmentIds && user.departmentIds.length > 0) return [...user.departmentIds];
  if (!user && employee?.departmentIds && employee.departmentIds.length > 0) return [...employee.departmentIds];
  const single = user?.departmentId ?? employee?.departmentId ?? null;
  return single ? [single] : [];
}

export function branchToSend(personKey: string | null, workingBranchId: string): string | undefined {
  return personKey || !workingBranchId ? undefined : workingBranchId;
}

export function personBranchId(
  personKey: string | null,
  workingBranchId: string,
  user: { defaultBranchId: string | null } | null,
  employee: { branchId?: string | null } | null,
): string {
  if (!personKey) return workingBranchId;
  return user?.defaultBranchId ?? employee?.branchId ?? '';
}

export function departmentChoices(
  departments: readonly PlacedDepartment[],
  branchId: string,
  hospitalWide: boolean,
  allowedBranchIds: ReadonlySet<string>,
): PlacedDepartment[] {
  return departments.filter((department) => department.branchId === branchId && (hospitalWide || allowedBranchIds.has(department.branchId)));
}

export function doctorLacksLogin(isDoctor: boolean, signsIn: boolean, mayCreateLogin: boolean): boolean {
  return isDoctor && !signsIn && mayCreateLogin;
}
